import type { ICheckFingerprint, IUserFingerprintData } from './fingerprint.model';
import { fingerprintApiExtract } from './fingerprint-api';

const checkFingerprint = (data: IUserFingerprintData) =>
  fingerprintApiExtract.post<ICheckFingerprint, IUserFingerprintData>('v1/fingerprint/check', {
    ...data,
  });

export const FingerprintService = {
  checkFingerprint,
};
